import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from 'src/components/translate';
import { toggleMobile } from '../../../../actions/filter';
import * as S from './styles';
import type { AppState } from 'src/reducers';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import Counter from '../counter';

type FilterMobileToggleProps = {
  filterSettings: Record<string, unknown>;
};

export const FilterMobileToggle: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<FilterMobileToggleProps>>
> = props => {
  const { filterSettings = {} } = props;
  const isOpen = useSelector(
    (state: AppState) => state.areas.category.filter.mobileOpen
  );
  const dispatch = useDispatch();
  const count = Object.keys(filterSettings).length;

  return (
    <S.FilterMobileToggle>
      <PrimaryButton
        style={{ width: '100%' }}
        onClick={() => dispatch(toggleMobile(!isOpen))}
      >
        {count > 0 && <Counter count={count} />}
        <Translate domain="filter">button.filter</Translate>
      </PrimaryButton>
    </S.FilterMobileToggle>
  );
};
